/**
 *  © 2024 -2025 DXC Technology, all rights reserved.
 *  Material published by DXC Technology on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect, useState } from 'react';
import LazyLoad from 'react-lazyload';
import MU from '../../constants/muConstants';
import * as track from '../../utils/analytics';

const Products = (props) => {
  const [imagehover, setImagehover] = useState(false);
  const [shopUrl, setShopUrl] = useState('');
  const [productImageUrl, setProductImageUrl] = useState('');
  const container = props?.container;
  const productData = props?.productList;
  const shopIdConfiguration = MU?.shopIDs?.ShopIDConfiguration;
  const ecomProductShopId = props?.rendering?.fields?.EComProduct1?.value?.EComProduct1?.ShopID;
  // const ecomImageBaseURL = MU?.ecomData?.ecomImageBaseURL;
  const isProductImage = props?.productList?.images[0]?.hash;
  const productImage = productImageUrl && productImageUrl + isProductImage;
  const isProductHoverImg = props?.productList?.images[1]?.hash;
  const productHoverImage = productImageUrl && productImageUrl + isProductHoverImg;
  const productName = productData?.attributes?.name?.values?.label;
  const productId = productData?.id;
  const productMaxRetailPrice = productData?.priceRange?.max?.recommendedRetailPrice;
  const productMinRetailPrice = productData?.priceRange?.min?.recommendedRetailPrice;
  const productMaxPrice = productMaxRetailPrice && productMaxRetailPrice / 100;
  const productMinPrice = productMinRetailPrice && productMinRetailPrice / 100;
  const ecomShopUrl = productId && shopUrl + productId;
  const itemId = props?.rendering?.dataSource;
  const isNew = productData?.isNew;
  const isSoldOut = productData?.isSoldOut;
  const productMaxAppliedReductions =
    productData?.priceRange?.max?.appliedReductions[0]?.amount?.absoluteWithTax;
  const productMinAppliedReductions =
    productData?.priceRange?.min?.appliedReductions[0]?.amount?.absoluteWithTax;
  const productMinAppliedReductionsLength = productData?.priceRange?.min?.appliedReductions;
  const productMaxWithTax = productData?.priceRange?.max?.withTax;
  const productMinWithTax = productData?.priceRange?.min?.withTax;
  const productRelativeAmount = productData?.priceRange?.min?.appliedReductions[0]?.amount.relative;
  let productPrice;
  let productReducedPrice;
  let productPriceLabel;

  const extractTwoDecimalPlaces = (number) => {
    const numStr = String(number);
    const decimalIndex = numStr.indexOf('.');
    if (decimalIndex === -1) {
      return numStr; // No decimal point, return the original string
    }
    const integerPart = numStr.slice(0, decimalIndex);
    const decimalPart = numStr.slice(decimalIndex + 1, decimalIndex + 3);
    if (Number(decimalPart) > 0) {
      return `${integerPart}.${decimalPart}`;
    } else {
      return integerPart;
    }
  };

  const handleProductPrice = () => {
    if (productMinRetailPrice === productMaxRetailPrice) {
      productPrice = productMinRetailPrice;
    } else {
      productPrice = productMinRetailPrice - productMaxRetailPrice;
    }

    if (Object.keys(productMinAppliedReductionsLength)?.length > 0) {
      if (productMinAppliedReductions === productMaxAppliedReductions) {
        productReducedPrice = productMinWithTax;
      } else productReducedPrice = productMinWithTax - productMaxWithTax;
    }

    if (productPrice === productReducedPrice) {
      return <span className="price-tag main-price">£{(productPrice / 100)?.toFixed(2)} </span>;
    } else {
      if (productReducedPrice !== undefined) {
        return (
          <div>
            <span className="price-tag main-price price-strike">
              £{(productPrice / 100)?.toFixed(2)}{' '}
            </span>
            <span className="price-tag reduction-price">
              £{(productReducedPrice / 100)?.toFixed(2)}
            </span>
          </div>
        );
      }
      return <span className="price-tag main-price">£{(productPrice / 100)?.toFixed(2)} </span>;
    }
  };

  const handleProductPriceLabel = () => {
    handleProductPrice();
    if (
      (productReducedPrice !== null ||
        productReducedPrice !== undefined ||
        !isNaN(productReducedPrice)) &&
      (productPrice !== null || productPrice !== undefined || !isNaN(productPrice)) &&
      productPrice !== productReducedPrice
    ) {
      if (
        productRelativeAmount !== null ||
        productRelativeAmount !== undefined ||
        !isNaN(productRelativeAmount)
      ) {
        productPriceLabel = productRelativeAmount * 100;
        return (
          <span className="priceLabel">
            {'-' + extractTwoDecimalPlaces(productPriceLabel) + '%'}
          </span>
        );
      }
    }
  };

  const trackCard = (ctaTitle, linkUrl, e) => {
    const initialData = track.data('card');
    track.analytics(
      {
        ...initialData,
        card_name: ctaTitle,
        container_type: container,
        destination_url: linkUrl,
        item_id: itemId,
      },
      e
    );
  };

  useEffect(() => {
    if (shopIdConfiguration && ecomProductShopId) {
      const shopIdData = shopIdConfiguration.find((item) => item.ShopID === ecomProductShopId);
      setProductImageUrl(shopIdData.ImageURL);
      setShopUrl(shopIdData.ShopURL);
    }
  }, [shopIdConfiguration]);

  return (
    <React.Fragment>
      <a
        href={ecomShopUrl}
        target="_blank"
        tabIndex="0"
        rel="noreferrer"
        onClick={(e) => trackCard(productName, ecomShopUrl, e)}
      >
        <div className="grid-3 ratio">
          <div className="mu-content">
            <article className="ecommerce-card">
              <div className="ecommerce-card-item">
                {isProductImage && productImage && (
                  <>
                    <div className="img-holder">
                      <LazyLoad once={true} offset={100}>
                        <figure className="nobg">
                          <img className="productimg" src={productImage} alt="" />
                          {isProductHoverImg && productHoverImage && (
                            <img className="productimg-hover" src={productHoverImage} alt="" />
                          )}
                        </figure>
                      </LazyLoad>
                    </div>
                    <div className="cardLabel">
                      {isSoldOut ? (
                        <span className="soldOutLabel">{props.t('OutofStock')}</span>
                      ) : (
                        isNew && <span className="newLabel">{props.t('New')}</span>
                      )}
                      {!isNew && !isSoldOut && productRelativeAmount && handleProductPriceLabel()}
                    </div>
                  </>
                )}
              </div>
              {productMaxPrice && productMinPrice && (
                <div className="product-price-info">{handleProductPrice()}</div>
              )}
              {productName && (
                <div className="ecommerce-card__info ecom-btn">
                  <div id={productId} className="ecommerce-card__title">
                    {productName}
                  </div>
                </div>
              )}
            </article>
          </div>
        </div>
      </a>
    </React.Fragment>
  );
};

export default React.memo(Products);
